export default {
  adjustments: undefined,
  subscriptions: undefined,
  dataReturned: false,
  paymentType: true,
  page: 1,
};
